import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import {Collapse, Timeline} from 'antd'
import {CaretRightOutlined} from '@ant-design/icons'
import {Description} from '@/components/dumb/Description'
import {buildTransactionFields, buildChargebackFields, buildChargebackHistoryFields} from './utils'
import {ChargebacksDetailsProps} from './props'

import styles from './styles.scss'
import {
    CHARGEBACK_DETAILS_PART,
    CHARGEBACK_HISTORY,
    CHARGEBACK_ORIGINAL_TRANSACTION_DETAILS_PART
} from '@/constants/playwright-ids'

const {Panel} = Collapse

export const ChargebacksDetails: React.FC<ChargebacksDetailsProps> = ({
    data,
    chargeback,
    isMobile
}) => {
    const { t } = useTranslation()
    const originalTransaction = data.find((item) => item.category === 'original-transaction')
    const chargebackHistory = data.filter((item) => item.category !== 'original-transaction')

    const originalTransactionFields = buildTransactionFields(originalTransaction, chargeback)
    const chargebackFields = buildChargebackFields(chargeback)
    const chargebackHistoryFields = buildChargebackHistoryFields(chargebackHistory)

    return (
        <Collapse
            bordered={false}
            ghost
            defaultActiveKey={[0, 1, 2]}
            expandIcon={({isActive}) => (
                <CaretRightOutlined className={styles.expandIcon} rotate={isActive ? 270 : 90} />
            )}
            expandIconPosition={'end'}
            className={styles.accordion}
        >
            <Panel
                className={styles.panel}
                header={t('ChargebacksDetails.chargebacksDetails')}
                key={0}
                data-test-id={CHARGEBACK_DETAILS_PART}
            >
                <Description
                    dataSource={chargebackFields}
                    className={classNames(styles.description, {
                        [styles.descriptionMobile]: isMobile
                    })}
                />
            </Panel>
            <Panel
                className={styles.panel}
                header={t('ChargebacksDetails.originalTransactionDetails')}
                key={1}
                data-test-id={CHARGEBACK_ORIGINAL_TRANSACTION_DETAILS_PART}
            >
                <Description
                    dataSource={originalTransactionFields}
                    className={classNames(styles.description, {
                        [styles.descriptionMobile]: isMobile
                    })}
                />
            </Panel>
            <Panel
                className={styles.panel}
                header={t('ChargebacksDetails.chargebackHistory')}
                key={2}
                data-test-id={CHARGEBACK_HISTORY}
            >
                <Timeline mode='left' className={styles.timeline}>
                    {chargebackHistoryFields.map((field) => (
                        <React.Fragment key={field.key}>{field.render()}</React.Fragment>
                    ))}
                </Timeline>
            </Panel>
        </Collapse>
    )
}
